import { IFileResponse } from '@api/client';

export type FilePreviewUrlOptions = {
  fallbackUrl?: string | null;
  preferFallback?: boolean;
  skipFileUrl?: boolean;
};

export const getFilePreviewUrl = (
  file?: IFileResponse | null,
  options: FilePreviewUrlOptions = {}
): string | null => {
  const fallbackUrl = options.fallbackUrl ?? null;
  const preferFallback = options.preferFallback ?? false;
  const skipFileUrl = options.skipFileUrl ?? false;

  if (!file) return fallbackUrl;

  const originUrl = file.origin?.url;
  if (originUrl) return originUrl;

  if (preferFallback && fallbackUrl) return fallbackUrl;

  if (!skipFileUrl && file.url) return file.url;

  if (!preferFallback && fallbackUrl) return fallbackUrl;

  if (file.resizes?.length) {
    return file.resizes[file.resizes.length - 1]?.url || file.resizes[0]?.url || null;
  }

  return fallbackUrl;
};
